import { Box, IconButton } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React from 'react'
import { GridToolbar } from '../../../components/GridToolbar/GridToolbar'
import { useState } from 'react'
import { dataColumn } from '../../../components/DataColumn'
import { Delete } from '@mui/icons-material'
import { useEffect } from 'react'
import SupLoading from '../../../components/Loading/SupLoading'
import BankAddDialog from '../../SupplierEvaluation/BankAccount/BankAddDialog'

export default function VendorBank({ tableData, setTableData, vendorId, data, isLoading, country }) {


  useEffect(() => {
    if (!isLoading && data?.data?.vendorBankDetails?.length > 0) {
      setTableData(data?.data?.vendorBankDetails)
    } else {
      setTableData([])
    }

  }, [data, setTableData, isLoading])


  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };


  const columns = [
    {
      field: 'actions',
      headerName: 'Actions',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        return (
          <>
            <IconButton onClick={() => handleRowDelete(params.row.id)} sx={{ p: 0, marginLeft: 0.3 }} >
              <Delete sx={{ color: 'red' }} style={{ color: 'red' }} />
            </IconButton>
          </>
        )
      },
    },

    dataColumn('currency', 'Currency', 70),
    dataColumn('accountNumber', 'Bank Account Number', 200),
    dataColumn('bank', 'Bank Name', 150),
  ];


  const [editData, setEditData] = useState([])
  const [doubleClickBool, setDoubleClickBool] = useState(false)


  const handleDoubleClick = (params) => {
    setEditData(params.row)

    handleClickOpen();
    setDoubleClickBool(true)
  }


  const handleClose = () => {
    setOpen(false);

    setDoubleClickBool(false)
    setEditData([])
  };

  const handleRowDelete = (id) => {
    setTableData((prevTableData) =>
      prevTableData.map((row) => {
        if (row.id === id) {
          return { ...row, type: 2 };
        }
        return row;
      })
    );
  }


  // if (tableData?.filter((row) => row.type === 0)?.length > 0) {
  //   dispatch(nextStep())
  // }
  // else {
  //   showWarningToast(`Please enter at least one Bank Account`)
  // }

  return (
    <>
      {!isLoading ? (
        <>
          <Box sx={{ height: 240, width: '100%' }}>
            <DataGrid
              rows={tableData?.filter(item => item.type === 0) || []}
              columns={columns}
              getRowId={row => row.id}
              rowHeight={30}
              onRowDoubleClick={handleDoubleClick}
              showCellRightBorder
              components={{
                Toolbar: () => (
                  <GridToolbar
                    hiddenSearch={false}
                    handleAddRow={handleClickOpen}
                    hiddenRefresh={true}
                  />
                ),
              }}
            />
          </Box>
          <BankAddDialog open={open}
            handleClose={handleClose}
            doubleClickBool={doubleClickBool}
            editData={editData}
            vendorId={vendorId}
            setTableData={setTableData}
            tableData={tableData}
            currencies={data?.data?.currencies}
            country={country}
          />
        </>
      ) : <><SupLoading /></>}

    </>
  )
}
